import type { JSX } from 'react';
import { IconDownload } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { ActionIcon, AppShell, Burger, Button, Group, Text, Tooltip } from '@mantine/core';
import { useInstallPrompt } from '../../hooks';
import { ColorSchemeToggle } from '../ColorSchemeToggle';
import UserMenu from '../UserMenu';
import classes from './AppHeader.module.css';

interface IAppHeaderProps {
  opened: boolean;
  toggle: () => void;
}

function AppHeader({ opened, toggle }: Readonly<IAppHeaderProps>): JSX.Element {
  const { canInstall, promptInstall } = useInstallPrompt();

  return (
    <AppShell.Header className={classes.header}>
      <Group className={classes.headerContent} justify="space-between" wrap="nowrap" gap="xs">
        <Group className={classes.brandGroup} wrap="nowrap">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <Text className={classes.brandText} hiddenFrom="sm" component={Link} to="/">
            Grace Bible Church
          </Text>
        </Group>
        <Group gap="xs" wrap="nowrap" className={classes.controls}>
          {canInstall && (
            <>
              <Button
                visibleFrom="sm"
                size="xs"
                variant="light"
                leftSection={<IconDownload size={16} />}
                onClick={promptInstall}
              >
                Install app
              </Button>
              <Tooltip label="Install app">
                <ActionIcon
                  hiddenFrom="sm"
                  size="lg"
                  variant="light"
                  aria-label="Install app"
                  onClick={promptInstall}
                >
                  <IconDownload size={20} />
                </ActionIcon>
              </Tooltip>
            </>
          )}
          <ColorSchemeToggle />
          <UserMenu />
        </Group>
      </Group>
    </AppShell.Header>
  );
}

export default AppHeader;
